export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const PAGING_INFO = 'PAGING_INFO';
export const SELECTED_ROW = 'SELECTED_ROW';
export const DETAIL_FORM = 'DETAIL_FORM';
export const POPUP_INIT = 'POPUP_INIT';
export const POPUP_SEARCH_PARAMS = 'POPUP_SEARCH_PARAMS';

export default {
	SEARCH_PARAM,
	STATE_INIT,
	DEFAULT_ASSIGN,
	PAGING_INFO,
	SELECTED_ROW,
	POPUP_SEARCH_PARAMS,
	DETAIL_FORM,
	POPUP_INIT
};
